import React from 'react'

import * as S from './styles'

export type ButtonIconProps = {
  /**
   * Icon of the button
   *
   * @example
   * ```tsx
   * import { ListIcon } from '@/assets/icons'
   *
   * <ButtonIcon icon={ListIcon} />
   * ```
   *
   */
  icon: string

  /**
   * Alt of the icon
   *
   * @example
   * ```tsx
   * <ButtonIcon alt="Menu" />
   * ```
   *
   */
  alt: string

  /**
   * Icon's height
   *
   * @example
   * ```tsx
   * <ButtonIcon height={40} />
   * ```
   *
   */
  height?: number

  /**
   * Icon's width
   *
   * @example
   * ```tsx
   * <ButtonIcon width={40} />
   * ```
   *
   */
  width?: number

  /**
   * Function to be executed when the button is clicked
   *
   * @example
   * ```tsx
   * <ButtonIcon onClick={() => console.log('clicked')} />
   * ```
   *
   */
  onClick: () => void

  /**
   * Class name of the button
   *
   * @example
   * ```tsx
   * <ButtonIcon className="button-icon" />
   * ```
   *
   */
  className?: string
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({
  icon,
  alt,
  onClick,

  height = 48,
  width = 48,

  className,
}) => (
  <S.ImageButton
    src={icon}
    width={width}
    height={height}
    alt={alt}
    onClick={onClick}
    className={className}
  />
)
